import { Injectable } from '@angular/core';
import { MarketPrice } from '../models/market-price';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MarketPriceService {

  constructor(private http:HttpClient) { }

  getMarketPrices() : Promise<MarketPrice[]> {
    return this.http.get<MarketPrice[]>('/api/marketprice')
    .toPromise();
  }

  postMarketPrice(marketprice:MarketPrice): Promise<MarketPrice>{
    return this.http.post<MarketPrice>('/api/marketprice', marketprice)
    .toPromise();
  }

  getMarketPrice(id:Number) : Promise<MarketPrice>{
    return this.http.get<MarketPrice>('/api/marketprice/' + id)
    .toPromise();
  }

  putMarketPrice(marketprice:MarketPrice) : Promise<MarketPrice> {
    return this.http.post<MarketPrice>('/api/marketprice/' + marketprice.id + '/edit', marketprice)
    .toPromise();
  }

  deleteMarketPrice(marketprice:MarketPrice) : Promise<void> {
    return this.http.get<void>('/api/marketprice/' + marketprice.id + '/delete')
    .toPromise();
  }

}